<div class="guided-contract" [class.guided-contract--editable]="editable">
	<div class="guided-contract__summary">
		<div>
			<strong>
				{{ formattedDocumentTitle || 'Contrato organizado por seções' }}
			</strong>
			<p>
				{{ sections.length }}
				{{
					sections.length === 1 ? 'seção identificada' : 'seções identificadas'
				}}
			</p>
		</div>
		<mat-icon class="guided-contract__summary-icon" aria-hidden="true">
			view_agenda
		</mat-icon>
	</div>

	<div class="guided-contract__sections">
		<section
			class="guided-section"
			*ngFor="let section of sections; trackBy: trackSection"
		>
			<header class="guided-section__header">
				<span class="guided-section__index" aria-hidden="true">
					<mat-icon>description</mat-icon>
				</span>
				<div class="guided-section__title">
					<label
						[for]="section.id + '-title'"
						*ngIf="editable && section.headingStyle !== 'virtual'"
					>
						Título da seção
					</label>
					<input
						*ngIf="editable && section.headingStyle !== 'virtual'"
						[id]="section.id + '-title'"
						type="text"
						[value]="section.title"
						(input)="updateTitle(section.id, $event)"
					/>
					<h3 *ngIf="!editable || section.headingStyle === 'virtual'">
						{{ formatTitle(section.title) }}
					</h3>
				</div>
				<button
					mat-icon-button
					type="button"
					class="guided-section__remove"
					*ngIf="editable"
					[disabled]="sections.length <= 1"
					[matTooltip]="
						sections.length <= 1
							? 'O contrato precisa ter ao menos uma seção.'
							: 'Remover seção'
					"
					[attr.aria-label]="'Remover seção ' + section.title"
					(click)="removeSection(section.id)"
				>
					<mat-icon svgIcon="sanus-trash-blue"></mat-icon>
				</button>
			</header>

			<div class="guided-section__body">
				<p class="guided-section__label" *ngIf="editable">Conteúdo da seção</p>
				<app-contract-rich-content
					[editable]="editable"
					[value]="section.content"
					(valueChange)="updateContent(section.id, $event)"
				></app-contract-rich-content>
			</div>
		</section>
	</div>

	<div class="guided-contract__actions" *ngIf="editable">
		<button
			mat-stroked-button
			color="primary"
			type="button"
			(click)="addSection()"
		>
			<mat-icon svgIcon="sanus-add-blue"></mat-icon>
			Adicionar seção
		</button>
	</div>
</div>
